












import { computed, defineComponent } from '@vue/composition-api';
import { DateTime } from 'luxon';
import { ParagraphSize } from '@getaccept/lib-ui';
import { t } from '../../helpers/translation.helper';
import { DateHelper } from '../../helpers/date.helper';

export default defineComponent({
  props: {
    createdAt: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const localizedDate = computed(() => {
      if (!props.createdAt) {
        return '';
      }

      const date = DateTime.fromMillis(props.createdAt);

      if (DateHelper.isToday(date)) {
        return t('Today').toString();
      }
      if (DateHelper.isYesterday(date)) {
        return t('Yesterday').toString();
      }

      return date.toLocaleString(DateTime.DATE_SHORT);
    });

    const localizedTime = computed(() => {
      if (!props.createdAt) {
        return '';
      }

      const date = DateTime.fromMillis(props.createdAt);

      return date.toLocaleString(DateTime.TIME_SIMPLE);
    });

    return { localizedDate, localizedTime, ParagraphSize };
  },
});
